import ReactGA from "react-ga4";
import { Component } from "react";

export default class AnalyticsService extends Component {
  static initialize(analyticsIdentifier) {
    ReactGA.initialize(analyticsIdentifier, { debug_mode: false });
  }

  static sendPageView(pathname) {
    ReactGA.send({
      hitType: "pageview",
      page: pathname,
      debug_mode: false,
    });
  }
}
